<script lang="ts">
    import { onMount } from 'svelte';
    import jQuery from 'jquery';
    import "survey-core/defaultV2.css";
    import { Model, setLicenseKey, surveyLocalization } from 'survey-jquery';
    import { createEventDispatcher } from 'svelte';
    import { locale } from '../../../services/i18n.js';
    import { themeJson } from "./theme";

    export let stringifiedJson = '';
    export let stringifiedData = '';
    export let showNavigationButtons = true;
    export let mode = 'edit';
    export let submitFunction = () => {};

    const dispatch = createEventDispatcher();

    let parsedJson = parseAndAdjustJson(stringifiedJson);
    surveyLocalization.defaultLocale = "it";

    let survey: Model;
    let isInitializing = true;

    onMount(() => {
        survey = initializeSurvey(parsedJson, themeJson);
        survey.locale = $locale;

        if (stringifiedData) {
            survey.data = JSON.parse(stringifiedData);
        } else {
            // Inizializza il JSON con chiavi vuote
            stringifiedData = JSON.stringify(createEmptyDataObject(survey));
            survey.data = JSON.parse(stringifiedData);
        }

        setupJQuerySurvey(survey, showNavigationButtons);
        isInitializing = false;
    });

    $: if (survey) {
        survey.locale = $locale;
    }

    $: if (survey && stringifiedData) {
        survey.data = JSON.parse(stringifiedData);
    }

    function parseAndAdjustJson(jsonString) {
        if (!jsonString) return {};
        const json = JSON.parse(jsonString);
        adjustJson(json);
        return json;
    }

    function adjustJson(json) {
        const loopNestedObj = (obj) => {
            Object.entries(obj).forEach(([key, val]) => {
                if (val && typeof val === 'object') {
                    loopNestedObj(val);
                } else {
                    if (key === 'showOtherItem' && val === true) obj['hasOther'] = true;
                    if (key === 'showNoneItem' && val === true) obj['hasNone'] = true;
                }
            });
        };
        loopNestedObj(json);
    }

    function createEmptyDataObject(survey: Model) {
        const emptyData = {};
        survey.getAllQuestions().forEach(question => {
            emptyData[question.name] = null;
        });
        return emptyData;
    }

    function initializeSurvey(parsedJson, themeJson) {
        let survey = new Model(parsedJson);
        setLicenseKey(process.env.SURVEYJS_KEY);
        survey.applyTheme(themeJson);
        survey.focusFirstQuestionAutomatic = false;
        survey.mode = mode;
        
        survey.onTextMarkdown.add(function(sender, options) {
            let str = options.text;
            if (str.indexOf("<p>") === 0) {
                str = str.substring(3);
                str = str.substring(0, str.length - 4);
            }
            options.html = str;
        });
        
        survey.onComplete.add(() => saveSurveyData(survey));
        survey.onValueChanged.add((sender, options) => {
            if (!isInitializing) {
                stringifiedData = JSON.stringify(sender.data);
                dispatch('dataChange', { stringifiedData });
            }
        });
        return survey;
    }

    function saveSurveyData(survey: Model) {
        stringifiedJson = JSON.stringify(survey.toJSON());
        stringifiedData = JSON.stringify(survey.data);
        survey.render();
        submitFunction();
    }

    function setupJQuerySurvey(survey, showNavigationButtons) {
        jQuery($ => {
            const options = {
                model: survey,
                onCurrentPageChanged: doOnCurrentPageChanged,
                onValueChanged: doOnCurrentPageChanged
            };
            if (showNavigationButtons) {
                delete options.onCurrentPageChanged;
                delete options.onValueChanged;
            }
            $('#surveyContainer').Survey(options);
        });
        if (!showNavigationButtons) {
            setTimeout(() => doOnCurrentPageChanged(survey), 5000);
        }
    }

    function doOnCurrentPageChanged(survey) {
        const prevButton = document.getElementById('surveyPrev');
        const nextButton = document.getElementById('surveyNext');
        const pageNoInput = document.getElementById('surveyPageNo');

        if (prevButton) prevButton.style.display = !survey.isFirstPage ? 'inline' : 'none';
        if (nextButton) nextButton.style.display = !survey.isLastPage ? 'inline' : 'none';
        if (pageNoInput) (pageNoInput as HTMLInputElement).value = survey.currentPageNo;

        if (survey.isLastPage && !survey.isCurrentPageHasErrors) {
            stringifiedData = JSON.stringify(survey.data);
            dispatch('dataChange', { stringifiedData });
        }
    }

    export function updateFromJSON(newJSONData: string) {
        try {
            const parsedData = JSON.parse(newJSONData);
            survey.data = parsedData;
            stringifiedData = newJSONData;
            survey.render();
        } catch (e) {
            console.error('Errore nell\'aggiornamento del JSON:', e);
        }
    }
</script>

<div id="surveyContainer"></div>
{#if !showNavigationButtons}
    <div id="surveyExternalNavigation" class="min-h-[2em] py-4">
        <button id="surveyPrev" on:click="{survey.prevPage}" class="float-left h-[2em] w-28 rounded-sm border-0 text-sm font-bold">Precedente</button>
        <button id="surveyNext" on:click="{survey.nextPage}" class="float-right h-[2em] w-28 rounded-sm border-0 text-sm font-bold">Successivo</button>
    </div>
{/if}
